import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';

import type { WosIconProp } from 'types/common_types';

import icons from './icons/index';

type IconProps = {
  icon: WosIconProp | IconProp;
  size?: SizeProp;
  className?: string;
};

function Icon({ icon, size = '1x', className = '' }: IconProps) {
  if (icons[icon as WosIconProp]) {
    const WosIcon = icons[icon as WosIconProp];
    return <WosIcon className={`wos-icon wos-icon--${size} ${className}`} />;
  }

  return <FontAwesomeIcon icon={icon as IconProp} size={size} className={className} />;
}

export default Icon;
